"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var pendableFormatCommands = null;
/**
 * Execute a document command
 * @param editor The editor instance
 * @param command The command to execute
 * @param addUndoSnapshotWhenCollapsed Optional, set to true to always add undo snapshot even current selection is collapsed.
 * Default value is false.
 * @param doWorkaroundForList Optional, set to true to do workaround for list in order to keep current format.
 * Default value is false.
 */
function execCommand(editor, command) {
    editor.focus();
    var formatter = function () { return editor.getDocument().execCommand(command, false, null); };
    var range = editor.getSelectionRange();
    if (range && range.collapsed) {
        editor.addUndoSnapshot();
        formatter();
        if (isPendableFormatCommand(command)) {
            // Trigger PendingFormatStateChanged event since we changed pending format state
            editor.triggerPluginEvent(13 /* PendingFormatStateChanged */, {
                formatState: roosterjs_editor_dom_1.getPendableFormatState(editor.getDocument()),
            });
        }
    }
    else {
        editor.addUndoSnapshot(formatter, "Format" /* Format */);
    }
}
exports.default = execCommand;
function isPendableFormatCommand(command) {
    if (!pendableFormatCommands) {
        pendableFormatCommands = Object.keys(roosterjs_editor_dom_1.PendableFormatCommandMap).map(function (key) { return roosterjs_editor_dom_1.PendableFormatCommandMap[key]; });
    }
    return pendableFormatCommands.indexOf(command) >= 0;
}
//# sourceMappingURL=execCommand.js.map